import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Ladder } from 'src/models/ladder.model';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';
import { AdminDialogSetLevelComponent } from './dialogAdminSetLevel.component';
import { AdminDialogSetLadderComponent } from './dialogAdminSetLadder.component';

@Component({
  selector: 'admin-paid',
  templateUrl: './paid.component.html',
  styleUrls: ['paid.component.scss']
})
export class AdminPaidComponent implements OnInit {
  public busy: boolean = false;
  public players: Player[] = [];
  public ladders: Ladder[] = [];
  public ladderId: string = "";
  public msg: string;
  public paidIds: string[] = [];

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private dialog: MatDialog,
    private routerLink: Router) {
    this.busy = false;
  }

  ngOnInit(): void {
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )

  }

  public fetchPlayers(value: string) {
    this.http.get<Player[]>(`/admin/getallplayers/${value}`).subscribe(
      (resp: Player[]) => {
        console.log(resp);
        this.players.length = 0;
        for (let p of resp) {
          this.players.push(new Player(p));
        }
      }
    );
  }
  public markPaid(evt: any, id: string, levelId) {
    evt.preventDefault();
    const user = this.players.find(f => f.id == id);
    if (confirm(`Are you sure you want to mark ${user.getFullName()} paid?`)) {
      this.paidIds.push(id);
      this.http.post('/admin/markpaid', {
        UserId: id,
        LevelId: levelId,
        LadderId: this.ladderId,
        paid: true
      }).subscribe(
        (resp) => { this.msg = "Success"; setTimeout(() => this.msg = null, 5000); this.fetchPlayers(this.ladderId); },
        (err) => { this.msg = err; console.error(err); }
      )
    }
  }
  public markUnPaid(evt: any, id: string, levelId) {
    evt.preventDefault();
    // remove this user
    this.paidIds = this.paidIds.filter(f => f != id);

    this.http.post('/admin/markpaid', {
      UserId: id,
      LevelId: levelId,
      LadderId: this.ladderId,
      paid: false
    }).subscribe(
      (resp) => { this.fetchPlayers(this.ladderId); },
      (err) => { this.msg = err; console.error(err); }
    )
  }
  public dropLadder(evt: any, id: string, levelId) {
    evt.preventDefault();
    const user = this.players.find(f => f.id == id);
    if (confirm(`Are you sure you want to drop ${user.getFullName()}?`)) {
      this.http.post('/admin/DropUser', {
        UserId: id,
        LevelId: levelId,
        LadderId: this.ladderId
      }).subscribe(
        (resp) => { this.msg = "Success"; setTimeout(() => this.msg = null, 5000); this.fetchPlayers(this.ladderId); },
        (err) => { this.msg = "ERROR: " + err; console.error(err); }
      )
    }
  }
  public levelDialog(evt: any, id: string, levelId) {
    evt.preventDefault();
    const dialogConfig = new MatDialogConfig();
    var dlg = this.dialog.open(AdminDialogSetLevelComponent, dialogConfig);
    //const user = this.players.find(f => f.id == id);
    dlg.afterClosed().subscribe(
      (level: string) => {
        if( level != null && level != '')
        {
          this.http.post('/admin/setlevel',
            {
              UserId: id,
              LevelId: levelId,
              LadderId: this.ladderId,
              NewLevelId: parseInt(level, 10)
            }).subscribe(
              (resp) => { this.msg = "Success"; setTimeout(() => this.msg = null, 5000); this.fetchPlayers(this.ladderId); },
              (err) => { this.msg = "ERROR: " + err; console.error(err); }
            )
        }
      }
    );
  }
  public ladderDialog(evt: any, id: string, levelId) {
    evt.preventDefault();
    const dialogConfig = new MatDialogConfig();
    var dlg = this.dialog.open(AdminDialogSetLadderComponent, dialogConfig);
    //const user = this.players.find(f => f.id == id);
    dlg.afterClosed().subscribe(
      (newladder: string) => {
        if( newladder != null && newladder != '')
        this.http.post('/admin/setladder',
          {
            UserId: id,
            LevelId: levelId,
            LadderId: this.ladderId,
            NewLadderId: newladder
          }).subscribe(
            (resp) => { this.msg = "Success"; setTimeout(() => this.msg = null, 5000); this.fetchPlayers(this.ladderId); },
            (err) => { this.msg = "ERROR: " + err; console.error(err); }
          )
      }
    );
  }

  public showHistory(evt: any, userId: string) {
    evt.preventDefault();
    window.open(`/history?userId=${userId}`, '_blank');
  }

}
